import { useEffect, useState } from 'react';

const AUTH_CHANGED = 'sm-auth-changed';

export function notifyAuthChanged(): void {
  window.dispatchEvent(new Event(AUTH_CHANGED));
}

export function useOwnedProductIds(): Set<string> {
  const [ownedIds, setOwnedIds] = useState<Set<string>>(new Set());
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    const refresh = () => setRevision((value) => value + 1);
    window.addEventListener(AUTH_CHANGED, refresh);
    return () => window.removeEventListener(AUTH_CHANGED, refresh);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setOwnedIds(new Set());
      return;
    }
    let cancelled = false;
    fetch('/api/account/entitlements', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (cancelled || !data) return;
        const ids = (data.entitlements || [])
          .filter((item: { subjectType?: string; subjectId?: string }) => item.subjectType === 'product' && item.subjectId)
          .map((item: { subjectId: string }) => String(item.subjectId));
        setOwnedIds(new Set(ids));
      })
      .catch(() => {
        if (!cancelled) setOwnedIds(new Set());
      });
    return () => {
      cancelled = true;
    };
  }, [revision]);

  return ownedIds;
}
